/// <reference path="hero.HeroMediaBase.js" />
/// <reference path="image-zoom.js" />
/*
 * PDP hero wrapper for standard product images
 */
var ProductImageHero = (function ($) {
    var selectors = {
        enlargeLink: '.js-pdp-hero-enlarge-link',
        heroContainer: '.js-pdp-hero-container',
        modelInfoLink: '.js-pdp-hero-model-info-link',
        sizeShownInfo: '.js-pdp-hero-size-shown'
    };
    var productImageHero = function ($container, $mediaElement) {
        /// <summary>
        /// Constructor for ProductImageHero objects
        /// </summary>
        /// <param name="$container" type="JQueryObject">The jquery wrapper of the hero image container div</param>
        /// <param name="$mediaElement" type="JQueryObject">The jquery wrapper of the hero image/iframe element</param>
        var that = this;

        HeroMediaBase.call(that, $container, $mediaElement);
        that.imageInfo = imagesByProductImageId[$mediaElement.data('imageid')];
        that.$alternateImage.children('img').attr('src', that.imageInfo.AlternateImageUrl);
    };

    productImageHero.prototype = Object.create(HeroMediaBase.prototype);
    productImageHero.prototype.constructor = productImageHero;

    productImageHero.prototype.select = function () {
        var that = this;
        HeroMediaBase.prototype.select.call(that);

        //if the image's source isn't set,
        //add some preloading styles, set the source and remove the styles once the image loads
        //a 'src' attribute value of 'data:,' is used as a valid HTML placeholder for an empty img element
        if (!that.$mediaElement.attr('src') || that.$mediaElement.attr('src') === 'data:,') {
            var $heroImageContainer = that.$mediaElement.closest(selectors.heroContainer);
            $heroImageContainer.addClass('loading');
            that.$mediaElement
                .addClass('fade-out')
                .load(function () {
                    $heroImageContainer.removeClass('loading');
                    that.$mediaElement.removeClass('fade-out');
                })
                .attr('src', that.imageInfo.HeroImageUrl);
        }

        //reset the zoom for the current hero image
        that.$mediaElement.productZoom({ zoomPath: that.imageInfo.ZoomImageUrl });

        //reset the enlarge link
        that.$container.find(selectors.enlargeLink).attr('href', that.imageInfo.EnlargeImageUrl);

        //display/hide the size shown link if we have something to display
        var sizeShown = typeof that.imageInfo.SizeShown === "undefined" ? null : that.imageInfo.SizeShown;
        that.$container.find(selectors.sizeShownInfo).toggleClass('hidden', that.imageInfo.SizeShown ? false : true).children('.pdp-size-shown-value').html(sizeShown);

        //display/hide the model information link if we have something display
        that.$container.find(selectors.modelInfoLink).data('imageid', that.imageInfo.ProductImageId).toggleClass('hidden', that.imageInfo.ModelInfo ? false : true);
    };

    return productImageHero;
}(jQuery));